import { render, staticRenderFns } from "./editRiskLevel.vue?vue&type=template&id=51c13897&scoped=true"
import script from "./editRiskLevel.vue?vue&type=script&lang=js"
export * from "./editRiskLevel.vue?vue&type=script&lang=js"
import style0 from "./editRiskLevel.vue?vue&type=style&index=0&id=51c13897&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c13897",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c13897')) {
      api.createRecord('51c13897', component.options)
    } else {
      api.reload('51c13897', component.options)
    }
    module.hot.accept("./editRiskLevel.vue?vue&type=template&id=51c13897&scoped=true", function () {
      api.rerender('51c13897', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/security/components/editRiskLevel.vue"
export default component.exports